import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const HeroBlockTitle = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-hero__title", className)} {...other}>
      {children}
    </div>
  );
};

HeroBlockTitle.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

HeroBlockTitle.defaultProps = {
  className: "",
  children: null
};

export default HeroBlockTitle;
